import { defineMessages } from 'react-intl';

export const breadcrumbsMessages = defineMessages({
  showBreadcrumbsPath: { id: 'search.breadcrumbs.show.path', defaultMessage: 'Pfad anzeigen' },
});
